import React, { createContext, useContext, useState, useMemo } from 'react'
import invariant from 'tiny-invariant'
import PropTypes from 'prop-types'

const DragContext = createContext(null)

function useDragContext() {
  const context = useContext(DragContext)
  invariant(context, 'useDragContext must be used within a DragProvider')
  return context
}

function DragProvider({ children }) {
  const [dragType, setDragType] = useState(null)
  const [isDragging, setIsDragging] = useState(false)

  const value = useMemo(() => ({
    dragType,
    setDragType,
    isDragging,
    setIsDragging
  }), [dragType, isDragging])

  return (
    <DragContext.Provider value={value}>
      {children}
    </DragContext.Provider>
  )
}

DragProvider.propTypes = {
  children: PropTypes.node.isRequired
}

export { DragProvider, useDragContext }
